module.exports = __webpack_public_path__ + "static/media/SELECT_PAGE_IMAGE.190d4122.png";